export default __webpack_public_path__ + "static/media/full1.57d94ab8.jpg";